import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import styles from './styles.module.css';

/* Окно подтверждения поверх страницы (п. 7 ТЗ): заголовок вопросом, пояснение
   о последствиях, кнопки «Отмена» и красная «Удалить» (подпись действия
   переопределяется). Закрывается «Отменой», кликом по затемнённому полю и Esc. */

const ConfirmDialog = ({ title, text, yesLabel = 'Удалить', onYes, onNo }) => {
  const yesRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        onNo();
      }
    };
    document.addEventListener('keydown', onKey);
    if (yesRef.current) yesRef.current.focus();
    return () => document.removeEventListener('keydown', onKey);
  }, [onNo]);

  return createPortal(
    <div className={styles.ov} onMouseDown={(e) => { if (e.target === e.currentTarget) onNo(); }}>
      <div className={styles.win} role="dialog" aria-modal="true" aria-labelledby="portfolio-confirm-title">
        <div className={styles.winBody}>
          <div className={styles.winTitle} id="portfolio-confirm-title">{title}</div>
          <div className={styles.winText}>{text}</div>
        </div>
        <div className={styles.winFoot}>
          <button type="button" className={styles.no} onClick={onNo}>Отмена</button>
          <button type="button" className={styles.yes} ref={yesRef} onClick={onYes}>{yesLabel}</button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmDialog;
